import { useEffect, useState } from 'react';

type ColorPaletteProps = {
  colors?: string[];
  value?: string;
  onChange?: (newColor: string) => void;
};

export default function ColorPalette({
  colors = ['#e2e2e2', '#78e08f', '#fd79a8'],
  value = '',
  onChange,
}: ColorPaletteProps) {
  const [color, setColor] = useState(value);

  useEffect(() => {
    if (value !== color) {
      setColor(value);
    }
  }, [value]);

  const handleChange = (newColor: string) => {
    setColor(newColor);
    onChange && onChange(newColor);
  };

  return (
    <div>
      <label>Cor</label>
      <div
        style={{
          display: 'flex',
          gap: '1.5rem',
          width: '100%',
          marginTop: '0.7rem',
        }}
      >
        {colors.map((c) => (
          <span
            key={c}
            style={{
              display: 'inline-block',
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              cursor: 'pointer',
              background: c,
              border: `2px solid ${c === color ? 'black' : 'transparent'}`,
            }}
            onClick={() => handleChange(c)}
          ></span>
        ))}
      </div>
    </div>
  );
}
